import { NgZone, OnInit, Component } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { } from 'googlemaps';
import { User } from '../_models/index';
import { UserService, CookieService, ProjectService, DataSourcesService, SaveOrderService, IntroService } from '../_services/index';

declare var $: any;
declare var google: any;
declare var gtag: Function;

@Component({
    moduleId: module.id,
    templateUrl: 'summary.component.html',
    styleUrls: ['summary.component.css']
})
export class SummaryComponent implements OnInit {
    public lat: number;
    public lng: number;

    currentUser: User;
    users: User[] = [];
    zoom = 4;
    googleMapType = 'roadmap';
    address: string;
    editAddress = "";
    editCity = "";
    dataSourcesData: any;
    projectData: any;
    orderConfirmation: any;
    pName = "";
    pNumber = "";
    username = "Username";
    customerId: string;
    optionArray = [];
    reqArray = [];
    optionKeyArray = [];
    optionValueArray = [];
    reqPName = "";

    selectedPac = [];
    selectedPro = [];
    selectedRpt = [];
    selectedPacPro = [];
    SelectedDataSource = [];
    SelectedDataSourceCode = [];
    packageOpt = [];
    packageAll = [];

    country: string;
    provstate: string

    selPac = [];
    altEmail = [];
    desArray = []; //production selected item
    rptSelectedArray = [];//report selected item
    mapToggle = "small";
    items: any;
    values: any;
    savedPackageAll = [];
    btnText = "Hide";
    savedGeoLayer: any;
    savedMultiGeoLayer = [];
    saveStatus: string;
    reqKey: any;
    optKey: any;
    uploadedFile = "";
    altInvoice = 'N'
    allkey = ['Project Name', 'Contact Name', 'P.O./Project Number', 'Special Instructions', 'Contact Email(s)', 'Property Size', 'Lot', 'Concession', 'Municipality', 'Legal Description', 'Land Use', 'Current Occupant(s)', 'Past Occupants'];
    allfield = ['site_name', 'contact_name', 'project_num', 'special_instructions', 'alternate_email', 'lot_building_size', 'lot', 'concession', 'municipality', 'legal_description', 'land_use', 'current_occupants', 'past_occupants'];
    noStrings = ['N/A', 'TBD', 'TBA', 'PENDING', 'NA', '-', '0', " "];
    constructor(private ngZone: NgZone, private router: Router, private userService: UserService, private cookieService: CookieService, private projectService: ProjectService, private datasourcesService: DataSourcesService, private saveOrderService: SaveOrderService,
        private introService: IntroService) {
        this.router.events.subscribe(event => {
            if (event instanceof NavigationEnd) {
                // gtag('js', new Date());
                // gtag('config', 'UA-65756200-2');
            }
        });
    }
    getProject(customerid: string, country: string, skey: string): void {
        this.projectService.getprojectInfo(customerid, country, skey).subscribe(projectData => {
            this.projectData = projectData;
            let required = projectData.REQUIRED_FIELDS;
            let optional = projectData.OPTIONAL_FIELDS;

            this.reqKey = Object.keys(required);
            this.optKey = Object.keys(optional);
            for (let key of this.reqKey) {
                this.reqArray.push(required[key]);
            }
            for (let key of this.optKey) {
                this.optionArray.push(optional[key]);
            }
            if (this.cookieService.getCookie('optionInfo')) {
                let allData = JSON.parse(this.cookieService.getCookie('optionInfo'));
                this.optionArray = [];
                this.reqArray = [];
                for (let key of this.optKey) {
                    let index = this.allkey.indexOf(key);
                    this.optionArray.push(allData[index]);
                }
                for (let key of this.reqKey) {
                    let index = this.allkey.indexOf(key);
                    this.reqArray.push(allData[index]);
                }
            } else if (this.cookieService.getCookie('pno')) {
                let pno = this.cookieService.getCookie('pno');
                let index = this.optKey.indexOf('P.O./Project Number');
                if (index > -1) {
                    this.optionArray[index] = pno;
                }
            }
        });
    }
    saveOrders(order: string, customerid: string, qid: string, bucket: string, skey: string): void {
        this.saveOrderService.saveOrder(order, customerid, qid, bucket, skey).subscribe(result => {
            if (result.status == "Error") {
                this.saveStatus = result.message;
            } else {
                if ((result.orderid).indexOf("error") != -1) {
                    this.saveStatus = result.orderid;
                    return;
                }
                this.cookieService.clearAll();

                this.ngZone.run(() => {
                    this.router.navigate(['/checkout']);
                });
            }
        },
            error => this.orderConfirmation = error);
    }

    ngOnInit() {
        if (!this.cookieService.getCookie('customerID')) {
            return;
        }
        let Center;

        this.introService.setSummaryOptions();
        if (this.cookieService.getCookie("altInvoice")) {
            this.altInvoice = this.cookieService.getCookie("altInvoice");
        }
        if (this.cookieService.getCookie('customerName')) {
            this.username = this.cookieService.getCookie('customerName');
        }
        if (this.cookieService.getCookie('customerID')) {
            this.customerId = this.cookieService.getCookie('customerID');
        }
        if (this.cookieService.getCookie('PName')) {
            this.pName = this.cookieService.getCookie('PName');
        }
        if (this.cookieService.getCookie('altEmail')) {
            this.altEmail = (this.cookieService.getCookie('altEmail')).split(",");
        }
        if (this.cookieService.getCookie('DataSources')) {
            this.SelectedDataSource = JSON.parse(this.cookieService.getCookie('DataSources'));
        }
        if (this.cookieService.getCookie('DataSourcesCode')) {
            this.SelectedDataSourceCode = JSON.parse(this.cookieService.getCookie('DataSourcesCode'));
        }

        if ((this.cookieService.getCookie('selectedGeometry')) && (this.cookieService.getCookie('geoType'))) {

            let savedGeoType = this.cookieService.getCookie('geoType');
            let Geom = JSON.parse(this.cookieService.getCookie('selectedGeometry'));


            let savedGeom = Geom[0];
            let savedGeom1 = [];
            for (let i = 0; i < savedGeom.length; i++) {
                let pointJson = { lat: savedGeom[i][1], lng: savedGeom[i][0] };
                savedGeom1.push(pointJson);
            }
            Center = savedGeom1[0];
        } else {
            Center = new google.maps.LatLng(39.5673692, -103.6296376);
        }

        let Zoom = 16;
        let orderInfo: any;
        if (this.cookieService.getCookie('Order')) {
            orderInfo = JSON.parse(this.cookieService.getCookie('Order'));
        }
        this.address = orderInfo.provstate + ", " + orderInfo.postalzip + ", " + orderInfo.country;
        this.editCity = orderInfo.city;
        if (this.cookieService.getCookie('userInput')) {
            let savedInput = this.cookieService.getCookie('userInput');
            this.editAddress = savedInput.replace(/U002C/g, ",");
        }

        if (this.cookieService.getCookie('Product')) {
            this.selectedPro = JSON.parse(this.cookieService.getCookie('Product'));
        }
        if (this.cookieService.getCookie('Package')) {
            this.selectedPac = JSON.parse(this.cookieService.getCookie('Package'));
        }

        if (this.cookieService.getCookie('PackageAll')) {
            if (this.selectedPac) {
                this.packageAll = JSON.parse(this.cookieService.getCookie('PackageAll'));
            }
            if (this.packageAll) {
                for (let pac of this.packageAll) {
                    this.savedPackageAll.push(pac.proP.PRODUCT_CODE);
                }
            }
        }

        if (this.cookieService.getCookie('Product')) {
            let selPro = JSON.parse(this.cookieService.getCookie('Product'));
            for (let i = 0; i < selPro.length; i++) {
                this.desArray.push(selPro[i].Spro.PRODUCT_NAME);
            }
            this.selectedPro = selPro;
        }
        if (this.cookieService.getCookie('Report')) {
            let selRpt = JSON.parse(this.cookieService.getCookie('Report'));
            for (let i = 0; i < selRpt.length; i++) {
                this.rptSelectedArray.push(selRpt[i].Srpt.PRODUCT_NAME);
            }
            this.selectedRpt = selRpt;
        }
        let that = this;
        if (this.cookieService.getCookie('SATVIEW') == 'Y') {
            that.googleMapType = 'satellite';
        }

        let el = document.getElementById("googleMapsmall1");
        let mapOp = {
            center: Center,
            zoom: Zoom - 1,
            controlSize: 24,
            scaleControl: true,
            fullscreenControl: false,
            mapTypeId: that.googleMapType,
            mapTypeControlOptions: {
                position: google.maps.ControlPosition.TOP_RIGHT
            },
        };
        let map = new google.maps.Map(el, mapOp);
        let icon = {
            url: "assets/images/Site_Marker.png",
            scaledSize: new google.maps.Size(60, 40), // scaled size
            origin: new google.maps.Point(0, 0), // origin
            anchor: new google.maps.Point(30, 40)
        };
        if (this.cookieService.getCookie('UplaodFileName')) {
            this.uploadedFile = this.cookieService.getCookie('UplaodFileName');
        }
        if ((this.cookieService.getCookie('selectedGeometry')) && (this.cookieService.getCookie('geoType'))) {
            if (this.cookieService.getCookie('geoType') == "kml") {
                let fileUrl = this.cookieService.getCookie("UplaodGeometryFilelocation");
                let kmlLayer = new google.maps.KmlLayer({//need to clear other layer before add new layer
                    url: fileUrl,
                    suppressInfoWindows: true,
                    map: map,
                });
            } else {
                let savedGeoType = this.cookieService.getCookie('geoType');
                let Geom = JSON.parse(this.cookieService.getCookie('selectedGeometry'));

                if (Geom.length > 1) {
                    for (let geom of Geom) {
                        let savedGeom = geom;
                        let savedGeom1 = [];
                        for (let i = 0; i < savedGeom.length; i++) {
                            let pointJson = { lat: savedGeom[i][1], lng: savedGeom[i][0] };
                            savedGeom1.push(pointJson);
                        }
                        let geoLayer = new google.maps.Polygon({
                            paths: savedGeom1,
                            strokeColor: '#000',
                            strokeOpacity: 0.8,
                            strokeWeight: 2,
                            fillColor: 'rgb(195,212,47)',
                            fillOpacity: 0.65,
                            clickable: false,
                            map: map
                        });
                        this.savedMultiGeoLayer.push(geoLayer);
                    }
                } else {
                    let savedGeom = Geom[0];
                    let savedGeom1 = [];
                    for (let i = 0; i < savedGeom.length; i++) {
                        let pointJson = { lat: savedGeom[i][1], lng: savedGeom[i][0] };
                        savedGeom1.push(pointJson);
                    }

                    if (savedGeoType == "polygon") {
                        this.savedGeoLayer = new google.maps.Polygon({
                            paths: savedGeom1,
                            strokeColor: '#000',
                            strokeOpacity: 0.8,
                            strokeWeight: 2,
                            fillColor: 'rgb(195,212,47)',
                            fillOpacity: 0.65,
                            clickable: false,
                            map: map
                        });
                    } else if (savedGeoType == "polyline") {
                        this.savedGeoLayer = new google.maps.Polyline({
                            path: savedGeom1,
                            geodesic: true,
                            strokeColor: '#000',
                            strokeOpacity: 1.0,
                            strokeWeight: 2,
                            map: map
                        });
                    } else if (savedGeoType == "POINT") {
                        this.savedGeoLayer = new google.maps.Marker({
                            position: savedGeom1[0],
                            icon: icon,
                            anchorPoint: new google.maps.Point(0, -25),
                            map: map,
                        });
                    }
                }
            }
            //draw geometry
        } else {
            this.cookieService.deleteCookie('selectedGeometry');
            this.cookieService.deleteCookie('geoType');
        }
        if(this.cookieService.getCookie('orderPin')=='Y'&&orderInfo.order_pin){
            let pinGeom=JSON.parse(orderInfo.order_pin)[0][0];
            let position={lat:pinGeom[1], lng:pinGeom[0] }
            let pinMarker = new google.maps.Marker({
                position: position,
                map: map,
            });
        }
        //end of adding geometry
        google.maps.event.addListener(map, 'click', function () {
            let bigBox = document.getElementById("textArea");
            let reportBox = document.getElementById("reportArea");
            let box = document.getElementById("bigMapBox");
            if (this.mapToggle == "small") {
                box.className = "col-md-12";
                el.style.height = "400px";
                el.style.width = "100%";
                bigBox.style.display = "none";
                reportBox.style.display = "none";
                google.maps.event.trigger(map, 'resize');
                map.setCenter(Center);
                map.setZoom(Zoom);
                this.mapToggle = "big";
                document.getElementById("close_text").style.display = "block";
                document.getElementById("open_text").style.display = "none";
            } else {
                box.className = "col-md-6";
                el.style.height = "160px";
                el.style.width = "100%";
                bigBox.style.display = "block";
                reportBox.style.display = "block";
                google.maps.event.trigger(map, 'resize');
                map.setCenter(Center);
                map.setZoom(Zoom - 1);
                this.mapToggle = "small";
                document.getElementById("close_text").style.display = "none";
                document.getElementById("open_text").style.display = "block";
            }
        });
        this.country = this.cookieService.getCookie('country');
        if ((this.country == "Canada") || (this.country == "CAN")) {
            this.country = "CAN";
        } else if ((this.country == "United States") || (this.country == "USA")) {
            this.country = "USA";
        } else if ((this.country == "Mexico") || (this.country == "MEX")) {
            this.country = "MEX";
        }

        this.provstate = this.cookieService.getCookie('ProvState');
        let sessionKey = this.cookieService.getCookie("sessionKey");
        this.getProject(this.customerId, this.country, sessionKey);
    }

    saveRequired(idName): void {
        if ($("#" + idName).val()) {
            if (idName == "proName") {
                this.reqPName = $("#" + idName).val();
                this.cookieService.setCookieSession('PName', this.reqPName)
            }
        }
    }

    saveReq(order): void {
        this.reqArray[order] = ($("#" + "reqInput" + order).val()).trim();
        this.cookieService.setCookieSession('optionInfo', JSON.stringify(this.reqArray.concat(this.optionArray)));
    }

    saveOption(order): void {
        this.optionArray[order] = ($("#" + "input" + order).val()).trim();
        this.cookieService.setCookieSession('optionInfo', JSON.stringify(this.reqArray.concat(this.optionArray)));
    }

    public addtocart(): void {
        let qid = "";
        let bucket = "";
        let flag = true;

        if (this.cookieService.getCookie("sessionKey") == "") {
            return
        };

        for (let i = 0; i < $(".reqField").length; i++) {
            $("#" + "reqInput" + i).css({ "font-size": "13px", "height": "22px", "border": "0px solid #ff0000" })
        }
        if (!flag) {
            return
        }
        let orderId = "";
        $("#pnWarn").css("display", "none");
        $("#emailWarn").css("display", "none");
        let orderInfo: any;
        if (this.cookieService.getCookie('Order')) {
            orderInfo = JSON.parse(this.cookieService.getCookie('Order'))
        } else if (this.cookieService.getCookie('savedOrder')) {
            orderInfo = JSON.parse(this.cookieService.getCookie('savedOrder'));
        }
        if (orderInfo) {
            if ($("#editedAddress").val()) {
                orderInfo.address1 = $("#editedAddress").val();
                let input = $("#editedAddress").val();
                let modifiedinput = input.replace(/,/g, '\U002C');
                this.cookieService.setCookieSession("userInput", modifiedinput);
            }
            if ($("#editedC1").val()) {
                orderInfo.city = $("#editedC1").val();
            }
            if (this.cookieService.getCookie("OrderID")) {
                orderId = this.cookieService.getCookie("OrderID");
            }
            if (this.cookieService.getCookie("qid")) {
                qid = this.cookieService.getCookie("qid");
            }
            if (this.cookieService.getCookie("bucket")) {
                bucket = this.cookieService.getCookie("bucket");
            }

            for (let i = 0; i < $(".reqField").length; i++) {
                let reqValule = ($("#" + "reqInput" + i).val()).trim();
                if (reqValule != "" && this.noStrings.indexOf(reqValule.toUpperCase()) == -1) {
                    let label = $("#" + "reqInput" + i).parent().siblings('label').text();

                    this.reqArray[i] = reqValule;
                } else {
                    $("#" + "reqInput" + i).css({ "font-size": "13px", "height": "22px", "border": "1px solid #ff0000" })
                    $("#pnWarn").css("display", "block");
                    flag = false;
                }
            }
            if (!flag) {
                return
            }
            for (let i = 0; i < this.reqKey.length; i++) {
                let index = this.allkey.indexOf(this.reqKey[i]);
                if (index != -1) {
                    orderInfo[this.allfield[index]] = this.reqArray[i];
                }
            }

            for (let i = 0; i < this.optionArray.length; i++) {
                if ($("#" + "input" + i).val()) {
                    this.optionArray[i] = ($("#" + "input" + i).val()).trim();
                }
            }
            for (let j = 0; j < this.optKey.length; j++) {
                let index = this.allkey.indexOf(this.optKey[j]);
                if (index != -1) {
                    orderInfo[this.allfield[index]] = this.optionArray[j];
                }
            }


            if ($('#emailChk').is(':checked')) {
                orderInfo.optionalInvoice = "Y";
            } else {
                orderInfo.optionalInvoice = "N";
            }

            this.cookieService.setCookieSession("Order", JSON.stringify(orderInfo));

            let sessionKey = this.cookieService.getCookie("sessionKey");
            this.saveOrders(JSON.stringify(orderInfo), this.customerId, qid, bucket, sessionKey);
        }
    }

    saveUserInput() {
        if ($("#editedAddress").val()) {
            let inputAddress = $("#editedAddress").val();
            let modifiedinput = inputAddress.replace(/,/g, '\U002C');
            this.cookieService.setCookieSession("userInput", modifiedinput);
        }
    }

    public saveInputCity() {
        let orderInfo: any
        if (this.cookieService.getCookie('Order')) {
            orderInfo = JSON.parse(this.cookieService.getCookie('Order'));
        } else if (this.cookieService.getCookie('savedOrder')) {
            orderInfo = JSON.parse(this.cookieService.getCookie('savedOrder'));
        }
        if ($("#editedC1").val()) {
            orderInfo.city = $("#editedC1").val();
            this.cookieService.setCookieSession("Order", JSON.stringify(orderInfo));
        }
    }
}
